export interface Language {
  id: string;
  name: string;
  initial: string;
  direction: {
    id: string;
    name?: string;
  };
  isDefault: boolean;
  isTranslationEnable: boolean;
  isAutomaticSync: boolean;
  isNotify: boolean;
  autoTranslate: {
    id: string;
    name?: string;
  };
  translationMemory: {
    id: string;
    name?: string;
  };
  categories: Array<{
    id: string;
    name?: string;
  }>;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateLanguageData {
  name: string;
  initial: string;
  direction: {
    id: string;
  };
  isDefault: boolean;
  isTranslationEnable: boolean;
  isAutomaticSync: boolean;
  isNotify: boolean;
  autoTranslate: {
    id: string;
  };
  translationMemory: {
    id: string;
  };
  categories: Array<{
    id: string;
  }>;
}

export type UpdateLanguageData = Partial<CreateLanguageData>

export interface LanguageFilters {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  status?: string;
  direction?: string;
  isDefault?: boolean;
  isShowLoader?: boolean;
}

export interface LanguageResponse {
  data: Language[];
  totalCount: number;
  hasNextPage: boolean;
  currentPage: number;
  currentLimit: number;
}

export interface LanguageDirection {
  id: string;
  name: string;
  code: string;
}

export interface LanguageCategory {
  id: string;
  name: string;
  description?: string;
}

export interface TranslationSettings {
  id: string;
  name: string;
  description?: string;
}

export enum LanguageDirectionEnum {
  "ltr" = 1,
  "rtl" = 2,
}

export enum LanguageTranslationMemoryEnum {
  "enable" = 1,
  "disable" = 2,
}

export enum LanguageAutoTranslateEnum {
  "enable" = 1,
  "disable" = 2,
}

export enum TranslationEnableEnum {
  Disabled = "1",
  Enabled = "2"
}
